// extracted by mini-css-extract-plugin
export default {"clickable":"Oc32Ptg9Z3sG63MO4ad3"};